import type {
  EstateAgentListParams,
  EstateAgentQuery,
} from "@/api/temp/AgentEstateService";

/** Maps the real list params to the demo store's query; the UI sends one value per filter. */
export const toEstateAgentQuery = (
  params: EstateAgentListParams,
): EstateAgentQuery => ({
  environmentId: params.environmentId ?? "",
  q: params.search,
  platform: params.platform?.[0],
  businessUnit: params.businessUnit,
  project: params.project?.[0],
  environmentType: params.environmentType?.[0],
  connectedResource: params.connectedResource?.[0],
  purpose: params.purpose?.[0],
  securityStatus: params.securityStatus?.[0],
  hasRecommendations:
    params.hasRecommendations === undefined
      ? undefined
      : String(params.hasRecommendations),
  enforcementStatus: params.enforcementStatus?.[0],
  agentRegistryId: params.agentRegistryId,
  pageNo: params.pageNo,
  pageSize: params.pageSize,
  sortBy: params.sortBy,
  sortOrder: params.sortOrder as EstateAgentQuery["sortOrder"],
});
